import React from 'react'
import Chart from 'react-apexcharts'

const BarChart = ({ data, categories }) => {
  const state = {
    series: [{
      name: '',
      data
    }],
    options: {
      colors: ['#27C3F3'],
      chart: {
        dropShadow: {
          enabled: false,
        },
        type: 'bar',
        toolbar: {
          show: false
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          horizontal: true,
          dataLabels: {
            position: 'top',
          },
        }
      },
      plugins: {
        legend: {
          display: false,
        },
      },
      stroke: {
        show: true,
        width: 1,
        colors: ['#fff']
      },
      dataLabels: {
        enabled: true,
        offsetX: 20,
        style: {
          fontSize: '12px',
          colors: ['#000000']
        }
      },
      xaxis: {
        categories,
        labels: {
          show: false
        },
        axisBorder: {
          show: false,
          color: '#FFFFFF',
          height: 0,
        },
      },
      grid: {
        show: false,
      },
      yaxis: {
        show: true,
      }
    },
  };

  return (
    <Chart options={state.options} series={state.series} type="bar" height={313} />
  )
}

export default BarChart
